import { render, staticRenderFns } from "./SNPSwap.vue?vue&type=template&id=69dbc1b7&"
import script from "./SNPSwap.vue?vue&type=script&lang=js&"
export * from "./SNPSwap.vue?vue&type=script&lang=js&"
import style0 from "./SNPSwap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports